import { useParams } from "react-router-dom";

// Utils and Constants
import {
  getCitySpecificMediaList,
  getSelectedStretchesAndMediaCount,
  getSitesTotalImpressionsAndCost,
  getStaticAndDoohSitesCount,
} from "../media-selection/MediaContainerUtil";
import {
  getDigitalMediasSpotCount,
  getTotalOtsSplitForStretchesBasedOnSelectedMedias,
} from "../../utils/campaignPlanningUtil";
import { getCityMediasCPAI } from "../../utils/CpaiUtils";
import { getTotalReachOfSelectedMediasStretches } from "../../utils/ReachUtils";

// Components
import FiltersAndSelectionChipsCard from "./FiltersAndSelectionChipsCard";
import SelectionOverviewCard from "./SelectionOverviewCard";

// City Overview :: (DRAFT & REVIEW) Pages
export default function CityOverview({
  campaign,
  cityPlan,
  campaignMedias = [],
  roadStretchMap = {},
}) {
  const { cityId } = useParams();

  // city specific medias
  const citySpecificMediaList = getCitySpecificMediaList(
    campaignMedias,
    cityId
  );
  // selected stretch data and total mediaCount on stretch
  const { selectedStretchesMap, totalStretchesCount } =
    getSelectedStretchesAndMediaCount(cityPlan, roadStretchMap);

  const {
    static: staticSitesCount = 0,
    DOOH: doohSitesCount = 0,
    total: totalSelectedMediaCount,
  } = getStaticAndDoohSitesCount(citySpecificMediaList);

  // city plan data (for pure dooh campaigns)
  const { isDigital = false } = cityPlan || {};

  // spot count
  const digitalMediaSpotCounts = getDigitalMediasSpotCount(
    citySpecificMediaList
  );

  // sites card data
  const sitesCardData = [
    {
      title: "Stretches",
      value: totalStretchesCount,
    },
    {
      title: "Selected",
      value: totalSelectedMediaCount,
    },
    {
      title: isDigital ? "Spots" : "Static",
      value: isDigital ? digitalMediaSpotCounts : staticSitesCount,
    },
    {
      title: "DOOH",
      value: doohSitesCount,
    },
  ];

  // total impressions and cost
  const { totalEstCost = 0 } = getSitesTotalImpressionsAndCost(
    citySpecificMediaList
  );

  // city plan data
  const { roadStretchOtsMap = {} } = cityPlan || {};

  // Total OtsSplit For Stretches Based On Selected Medias
  const { ots = 0, targetOts = 0 } =
    getTotalOtsSplitForStretchesBasedOnSelectedMedias(
      roadStretchOtsMap,
      selectedStretchesMap,
      citySpecificMediaList
    );

  // getting CPAI for CampaignCityMedias (medias which are added to campaign)
  const { staticCpai = 0, doohCpai = 0 } = getCityMediasCPAI(
    citySpecificMediaList,
    cityPlan
  );

  // total reach for selected medias stretches
  const totalReach = getTotalReachOfSelectedMediasStretches(
    cityPlan,
    citySpecificMediaList,
    roadStretchMap
  );

  // ots & cost card data
  const otsAndCostCardData = [
    {
      title: "Total Impressions",
      value: ots,
    },
    {
      title: "TG Impressions",
      value: targetOts,
    },
    {
      title: "Total Reach",
      value: totalReach,
    },
    {
      title: "Estimated Cost",
      value: totalEstCost,
    },
    {
      title: "CPAI: Static",
      value: staticCpai,
      isDoStringManipulation: false,
    },
    {
      title: "CPAI: DOOH",
      value: doohCpai,
      isDoStringManipulation: false,
    },
  ];

  return (
    <>
      <div className="row">
        <div className="col-12 col-xl-6">
          <h5>City overview</h5>
          <SelectionOverviewCard data={sitesCardData} />
        </div>

        {/* filters card */}
        <FiltersAndSelectionChipsCard campaign={campaign} cityPlan={cityPlan} />
      </div>
      <div className="mt-4">
        <SelectionOverviewCard data={otsAndCostCardData} />
      </div>
    </>
  );
}
